export default __webpack_public_path__ + "static/media/makestories-logo.20228e38.svg";